
import React, { Component } from "react";
import {Button ,Well,ButtonGroup,Glyphicon,ToggleButtonGroup,ToggleButton,ControlLabel,FormGroup,FormControl,HelpBlock,InputGroup,Label,Form} from "react-bootstrap";
import Moment from 'react-moment';
import moment from "moment"
function pad(n, width, z) {
  z = z || '0';
  n = n + '';
  return n.length >= width ? n : new Array(width - n.length + 1).join(z) + n;
}

/*
function MacroSelect(props){

  let macrolist={"enum":[],"enumNames":[]}

  for (var key in props.macros){
    macrolist.enum.push(key)
    macrolist.enumNames.push(props.macros[key].name)
  }


  return (<select key={"LogicCreateMacroChoice-"+props.id} value={props.current} onChange={(e)=>props.callback(e,props.id)}>
    <option value="">None</option>
      {macrolist.enum.map((d,i) =><option value={d} key={d}>{macrolist.enumNames[i]}</option>)}
    </select>)
}*/

function MacroSelect(props){

  let macrolist={"enum":[],"enumNames":[]}
  let tempsort=[]

  for (var key in props.macros){
      tempsort.push([props.macros[key].name,key])
    //  macrolist.enum.push(key)
  //    macrolist.enumNames.push(props.macros[key].name)
  }

  tempsort.sort()
  for (var key in tempsort){
    macrolist.enum.push(tempsort[key][1])
    macrolist.enumNames.push(tempsort[key][0])
  }

  return (<select key={"LogicCreateMacroChoice-"+props.id} value={props.current} onChange={(e)=>props.callback(e,props.id)}>
    <option value="">None</option>
      {macrolist.enum.map((d,i) =><option value={d} key={d}>{macrolist.enumNames[i]}</option>)}
    </select>)
}







function TimeString(props){

  console.log(props.data)

  let days=[]
/*  if( props.data.wdays.includes("every")){
    days.push((<Label bsStyle="info">Every Day</Label>))
  }*/

  if( props.data.wdays.includes("mon")){
    days.push((<Label bsStyle="info">Monday</Label>))
  }
  if( props.data.wdays.includes("tue")){
    days.push((<Label bsStyle="info">Tuesday</Label>))
  }
  if( props.data.wdays.includes("wed")){
    days.push((<Label bsStyle="info">Wednesday</Label>))
  }
  if( props.data.wdays.includes("thu")){
    days.push((<Label bsStyle="info">Thursday</Label>))
  }
  if( props.data.wdays.includes("fri")){
    days.push((<Label bsStyle="info">Friday</Label>))
  }

  if( props.data.wdays.includes("sat")){
    days.push((<Label bsStyle="info">Saturday</Label>))
  }
  if( props.data.wdays.includes("sun")){
    days.push((<Label bsStyle="info">Sunday</Label>))
  }

  let hours=pad(props.data.hours,2)
  let mins=pad(props.data.mins,2)
  let secs=pad(props.data.secs,2)

  let timestr=""


  //Interval

  if(props.data.setStart==false){
      if(props.data.hours!=0){
          timestr="Every "+hours+"h"+mins+"m"+ secs+"s"
      }else{
        if(props.data.mins!=0){
          timestr="Every "+mins+"m"+ secs+"s"
        }
        else{
          timestr="Every "+secs+"s"
        }
      }
  }



  return <Moment >{(1000-2000)}</Moment>

  return (<span>{timestr}&nbsp;{days.map((e)=><span>{e}</span>)}</span>)


}



function formatTime(seconds) {
  const d = Math.floor(seconds / (3600*24));
  const h = Math.floor((seconds %(3600*24))/ 3600);
  const m = Math.floor((seconds % 3600) / 60);
  const s = seconds % 60;
  let timestr=""
  if(d>0){
    timestr=d+ " day"
  }
  //Add the plural
  if(d>1)
    timestr+="s "

  if(h>0){
    timestr+=" "+h+ " hour"
  }
    //Add the plural
  if(h>1)
    timestr+="s "

  if(m>0){
    timestr+=" "+m+ " minute"
  }
    //Add the plural
  if(m>1)
    timestr+="s "

  if(s>0){
    timestr+=" "+s+ " second"
  }
      //Add the plural
  if(s>1)
    timestr+="s "





  return timestr


}

function dayString(wdays){
  console.log("Day String")
  let i=0
  const days_abv=["mon","tue","wed","thu","fri","sat","sun"]
  const days_full=["Monday","Tuesday","Wednesday","Thursday","Friday","Saturday","Sunday"]
  if(wdays.includes("mon") && wdays.includes("tue") && wdays.includes("wed") && wdays.includes("thu") && wdays.includes("fri") && wdays.length==5)
    return "Every day Monday-Friday "
  if(wdays.includes("sat") && wdays.includes("sun") && wdays.length==2)
    return "Every Saturday & Sunday "
  if(wdays.length>=5){
    //say the days we dont run
    let exceptdays=[]
    for(i=0;i<days_abv.length;i++){
      console.log(days_abv[i])
      if(wdays.includes(days_abv[i])==false){
          exceptdays.push(days_full[i])
      }
    }
    if(exceptdays.length>1){
      exceptdays=exceptdays.join(' & ')
    }
    else{
      exceptdays=exceptdays[0]
    }
    return "Every day except "+exceptdays+" "
  }else{
    let tempStr="Every"

    for(i=0;i<wdays.length;i++){

      tempStr+=" "+days_full[days_abv.indexOf(wdays[i])]
      if(i!=wdays.length-1){
        if(i==wdays.length-2)
          tempStr+=" &"
        else
        tempStr+=","
      }
    }
    return tempStr
  }
  return "Unknown"
}

function InfoString(props){
  let d=props.data
  let wday_str="Every "
  let timesplit=""
  let at_str=(<span>@ {pad(d.data.hours,2)}:{pad(d.data.mins,2)}</span>)
  if(d.unit=="hour"){
    at_str=(<span>@ :{pad(d.data.mins,2)} minutes past</span>)
    if(d.data.mins==0){
      at_str= " on the hour"
    }
  }
  if(d.unit=="min" || d.unit=="sec"){
    at_str=""
  }
  if(d.unit=="day" && d.unit_value<=1){
    if(d.data.wdays.includes("every"))
      wday_str="Every day "
    else
      wday_str=dayString(d.data.wdays)
  }
  else{
  let duration_sec=0
  switch(d.unit){
    case "day":
      duration_sec=d.unit_value*(3600*24)
      break;
    case "hour":
      duration_sec=d.unit_value*3600
      break;
    case "min":
      duration_sec=d.unit_value*60
      break;
    case "sec":
      duration_sec=d.unit_value
      break;
  }
  timesplit=formatTime(duration_sec)
}







  return (<i>{wday_str} {timesplit} {at_str} </i>)
}


export default class ScheduleCreate extends Component {
    constructor(props) {
      super(props);
      let unit="day"
      let unit_value=1
      if(props.data.days>=1){
        unit="day"
        unit_value=props.data.days
      }
      else if(props.data.hours>=1){
        unit="hour"
        unit_value=props.data.hours
      }
      else if(props.data.mins>=1){
        unit="min"
        unit_value=props.data.mins
      }
      else if(props.data.secs>=1){
        unit="sec"
        unit_value=props.data.secs
      }

      this.state = {
        initialName:props.data.name,
        data:props.data,
        outEdit:false,
        unit:unit,
        value:["every"],
        unit_value:unit_value,
        macro:""
      };

    }

  componentWillMount() {

  }



  nameChange=(event)=>{
    console.log(event)
    let temp=this.state.data
    temp.name=event.target.value
    this.setState({data: temp});
  }

  unitChangeValue=(e)=>{
    console.log(e.target.value)
    if(this.state.unit=="day"){
      if(e.target.value>1){
        let temp=this.state.data
        temp.wdays=["every"]
        this.setState({data:temp})
      }
    }
    this.setState({"unit_value":e.target.value})
  }

  unitChangehour=(e)=>{
    console.log(e.target.value)

    let temp=this.state.data
    temp.hours=e.target.value
    this.setState({data:temp})
  }

  unitChangemin=(e)=>{
    console.log(e.target.value)
    let temp=this.state.data
    temp.mins=e.target.value
    this.setState({data:temp})

  }

  handleChange=(e)=>{
    console.log(e)

    let temp=this.state.data


    if(e.length==0){

      temp.wdays=["every"]
      this.setState({data:temp})
      return
    }

    if(e.length>=1)
      if(e[e.length-1]=="every"){
        temp.wdays=["every"]
        this.setState({data:temp})
        //this.setState({value:["every"]})
        return
    }

  if( (e.includes("mon")) && (e.includes("tue")) && (e.includes("wed")) && (e.includes("thu")) && (e.includes("fri")) && (e.includes("sat")) && (e.includes("sun")) ){
    console.log("Every day")
    temp.wdays=["every"]
    this.setState(temp)
    this.setState({data:temp})
    //this.setState({value:["every"]})
    return
  }else{
    if(e.length!=1){
      const index = e.indexOf("every");
      if (index > -1) {
        e.splice(index, 1);
      }
    }
    temp.wdays=e
    this.setState({data:temp})
    return
  }

}




/*
changeSetting=(e)=>{
  console.log(e.target.value)
  console.log(e.target.name)

  let update={}
  update[e.target.name]=e.target.value
  this.setState(update)
  console.log(update)
}*/


setUnit=(e)=>{
  console.log(e)
  let temp=this.state.data

  if(e!="day"){
    temp.days=0
    if(e=="min" || e=="sec"){
        temp.hours=0
        temp.mins=0
        temp.days=0
        temp.secs=0
        temp.setStart=false
    }
    if(e=="hour"){
      temp.hours=0
      temp.setStart=true
    }
    temp.wdays=["every"]
  }else{
    temp.setStart=true
  }
  this.setState({data:temp})
  this.setState({"unit":e})
}



macroSelect=(event,id)=>{

let macroid=event.target.value
let temp=this.state.data
temp.macro=macroid
this.setState({data:temp})

}

clearMacro=()=>{
  console.log("Macro Clear")
  let temp=this.state.data
  temp["macro"]=""
  this.setState({data: temp});



}


save=()=>{

  //Get data into
  let temp=this.state.data
  if(this.state.unit=="day"){
    temp.days=parseInt(this.state.unit_value)
  }
  if(this.state.unit=="hour"){
    temp.hours=parseInt(this.state.unit_value)
  }
  if(this.state.unit=="min"){
    temp.mins=parseInt(this.state.unit_value)
  }
  if(this.state.unit=="sec"){
    temp.secs=parseInt(this.state.unit_value)
  }

  temp.days=parseInt(temp.days)
  temp.hours=parseInt(temp.hours)
  temp.mins=parseInt(temp.mins)
  temp.secs=parseInt(temp.secs)


  if (temp.macro.length==0){
    alert("Select an action!")
    return
  }

  this.props.callback(temp,"save")

}
    render(){
      console.log(this.props)





      return (<div><Well bsSize="small">


      <h3>New Schedule --- <i>{this.state.data.name}</i></h3>

      <h4>Name</h4>
        <input value={this.state.data.name} onChange={this.nameChange}></input>
      </Well>
      <Well bsSize="small">
      <h4>Select an interval</h4>
      <i></i>
      <Button onClick={()=>this.setUnit('day')}>Days</Button>
      <Button onClick={()=>this.setUnit('hour')}>Hours</Button>
      <Button onClick={()=>this.setUnit('min')}>Minutes</Button>
      <Button onClick={()=>this.setUnit('sec')}>Seconds</Button>

      <hr/>
      <Form componentClass="fieldset" inline>

          <FormGroup controlId="formValidation" validationState="success">
            <ControlLabel>Every {this.state.unit_value} {this.state.unit}{this.state.unit_value>1 ?("s"):("")}</ControlLabel>{' '}
            <InputGroup>
              <InputGroup.Addon>{this.state.unit}</InputGroup.Addon>
              <FormControl type="number" min={1} max={999999} value={this.state.unit_value} onChange={this.unitChangeValue}/>
            </InputGroup>
            <br/>
            <br/>
            {this.state.unit=="day" && this.state.unit_value<=1 ?(
            <ToggleButtonGroup
                   type="checkbox"
                   value={this.state.data.wdays}
                   onChange={this.handleChange}
                 >
                   <ToggleButton value={"every"}>Every Day</ToggleButton>
                   <ToggleButton value={"mon"}>Monday</ToggleButton>
                   <ToggleButton value={"tue"}>Tuesday</ToggleButton>
                   <ToggleButton value={"wed"}>Wednesday</ToggleButton>
                   <ToggleButton value={"thu"}>Thursday</ToggleButton>
                   <ToggleButton value={"fri"}>Friday</ToggleButton>
                   <ToggleButton value={"sat"}>Saturday</ToggleButton>
                   <ToggleButton value={"sun"}>Sunday</ToggleButton>
            </ToggleButtonGroup>):(<i>Every Day</i>)}



            {this.state.unit == "day" || this.state.unit == "hour" ? (<div>
            <h4>Specific time:</h4>
            <span>Allows for an exact hour of the day or minute past the hour for the action to occur</span>
            <br/>
            <br/>

            {this.state.unit=="day" ?(
            <InputGroup>
              <InputGroup.Addon>Hour</InputGroup.Addon>
              <FormControl type="number" min={0} max={23} value={this.state.data.hours} onChange={this.unitChangehour}/>
            </InputGroup>

          ):("")}
  {this.state.unit=="day" || this.state.unit=="hour" ?(
            <InputGroup>
              <InputGroup.Addon>Minutes</InputGroup.Addon>
              <FormControl type="number" min={0} max={59} value={this.state.data.mins} onChange={this.unitChangemin}/>
            </InputGroup>
):("")}
</div>):("")}

          </FormGroup>
        </Form>




        <h3><InfoString data={this.state}>Every jiblet</InfoString></h3>

            </Well>
        <Well bsSize="small"><h4>Run</h4>
        <p> <i>Select or create a new Action</i></p>
<MacroSelect key="MacroSchedSelect" id="macro" current={this.state.data.macro}  macros={this.props.macros} callback={this.macroSelect}></MacroSelect>


{this.state.data.macro.length!=0? (<span><Button onClick={()=>this.clearMacro()}>Clear Action</Button><Button onClick={()=>this.props.callback({id:this.state.data.macro},"macroedit")}>Edit Action</Button></span>):("")}


  <Button onClick={()=>this.props.callback({},"macroNewSched")}>Create new action</Button>

</Well>




    <Well bsSize="small">

      <Button onClick={this.save}>Save</Button>
      </Well>

      </div>


    )




    }
}




/*
{/*  <input value={this.state.initialName} onChange={this.changeName}></input>


  {this.props.data.ctrlType=="RF_SOCKET" ?(<div>

  GROUP 0-255<input type="number"    min={0} max={255}   value={this.state.initialAddr} name="initialAddr" onChange={this.changeSetting} ></input>
  CHANNEL 0-255<input type="number"  min={0} max={255}   value={this.state.initialChn}  name="initialChn"  onChange={this.changeSetting} ></input>


    </div>
    ):("")}

    {this.props.data.ctrlType=="RELAY PACK" ?(<div>
    ADDRESS 0-256<input type="number"    min={0} max={256}   value={this.state.initialAddr} name="initialAddr" onChange={this.changeSetting} ></input>
    CHANNEL 0-8<input type="number"  min={0} max={8}   value={this.state.initialChn}  name="initialChn"  onChange={this.changeSetting} ></input>
      </div>
      ):("")}


  <Button onClick={()=>this.saveOutputName()}>Done</Button><Button onClick={()=>this.closeOutputName()}>Cancel</Button>
  <Button onClick={()=>this.deleteOutput()}>Delete</Button>
{this.props.data.ctrlType=="RF_SOCKET" ?(
<div className="pull-right">
<Button onClick={()=>this.showHelp()}>Help</Button>
</div>):(<span></span>)}
  {this.props.data.ctrlType=="RGB STRIP" ?(<div className="pull-right">
      {this.state.rgbAlert ? (<span onClick={()=>this.toggleAlert()}>Alert Mode Enabled</span>):(<span onClick={()=>this.toggleAlert()}>Alert Mode Disabled</span>)}
    </div>
    ):("")}
  </div>
):(
  <div>
  <h4>{this.props.data.name}&nbsp;<Glyphicon onClick={()=>this.editOutName()} title="Edit name" className="iconBut" glyph="pencil" />
  <OutControls data={this.props.data} callback={this.props.callback}/></h4>
  */



// WEBPACK FOOTER //
// ./src/programmerComponents/ScheduleCreate.js